// MarketerPickerSheet.jsx — 마케터 고르기 (2026-10-06, 끌어놓기 대신 누르는 방식)
//   'move'  : 담당 마케터 바꾸기 — 지금 담당 마케터는 목록에서 뺀다 → 고르면 이동 창(AssignmentMoveModal)
//   'assign': 배정 안 된 직원 배정하기 → 고르면 배정 창(AssignmentModal, 마케터 고정·직원 미리 채움)
//   숨긴 마케터도 고를 수 있게 목록 끝에 '숨김' 표시로 둔다(숨김은 화면에서만 감추는 기능).
import React, { useEffect, useMemo, useState } from 'react';
import Modal from '../../../components/Modal';
import { stdOutlineBtn } from '../adminlayout/designStandard';
import { SH } from './assignmentSheet.styles';

export function MarketerPickerSheet({ picker, marketers = [], hiddenIds = new Set(), countsByMarketer = {}, onPick, onClose }) {
  const [keyword, setKeyword] = useState('');
  useEffect(() => { setKeyword(''); }, [picker]);
  const isMove = picker?.purpose === 'move';
  const currentId = isMove ? Number(picker?.assignment?.marketer_user_id) : null;
  const personName = isMove ? picker?.assignment?.consultant_name : picker?.consultant?.name;

  const options = useMemo(() => {
    const q = keyword.trim().toLowerCase();
    return marketers
      .filter((m) => Number(m.id) !== currentId)
      .filter((m) => !q || String(m.name || '').toLowerCase().includes(q))
      .sort((a, b) => Number(hiddenIds.has(Number(a.id))) - Number(hiddenIds.has(Number(b.id))));
  }, [marketers, currentId, keyword, hiddenIds]);

  if (!picker) return null;
  const title = isMove ? `${personName || '1:1 직원'} 담당 마케터 바꾸기` : `${personName || '1:1 직원'} 배정하기`;
  const footer = (
    <div style={SH.footer}>
      <button type="button" style={stdOutlineBtn} onClick={onClose}>닫기</button>
    </div>
  );

  return (
    <Modal open title={title} icon="👥" onClose={onClose} footer={footer} width="min(520px, calc(100vw - 48px))" mobileSheet mobileSheetDragClose>
      <div style={SH.wrap}>
        <div style={SH.hint}>
          {isMove
            ? <>지금 담당은 <b>{picker.assignment?.marketer_name || '-'}</b>입니다. 새 담당 마케터를 고르면 언제부터 바꿀지 정하는 창이 열립니다.</>
            : <>누구의 1:1 직원으로 배정할지 고르세요. 고르면 시작일과 월급을 정하는 창이 열립니다.</>}
        </div>
        {marketers.length > 6 && (
          <input
            type="search"
            style={SH.search}
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="마케터 이름 검색"
            aria-label="마케터 이름 검색"
          />
        )}
        <div style={SH.list}>
          {options.length === 0 && (
            <div style={SH.empty}>{keyword.trim() ? '검색 결과가 없습니다.' : '고를 수 있는 다른 마케터가 없습니다.'}</div>
          )}
          {options.map((m) => {
            const count = Number(countsByMarketer[Number(m.id)] || 0);
            return (
              <button key={m.id} type="button" style={SH.pickRow} onClick={() => onPick(m)}>
                <span style={SH.pickName}>{m.name || `마케터 ${m.id}`}</span>
                <span style={SH.pickMeta}>
                  {hiddenIds.has(Number(m.id)) ? '숨김 · ' : ''}
                  {count > 0 ? `1:1 직원 ${count}명` : '배정 없음'}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </Modal>
  );
}
